import _ from "lodash";
import { createToast } from "./toast";
import { RequestHelper } from "./requestHelper";
import { _ACTIONS, _HTTP, _MEMBER, _SWAL_ICONS } from "./constants";
import { API, SLASH } from "./strings";
import { DataService } from "../services/DataService";
import { _ROUTES } from "./_routes_constants";

/**
 *
 * @param {any} value
 * @returns
 */
export function is(value) {
  return !_.isNull(value) && !_.isUndefined(value);
}

export function getQueryParamsFromFormData(formData, mode) {
  const params = {};
  //Boucler sur l'objet formData
  //Si la valeur est vide ou null, on ne l'ajoute pas
  //Sinon on l'ajoute dans params
  for (let key in formData) {
    let value = formData[key];
    if (mode === "edit" && key.includes(".")) {
      continue;
    }
    if (key.includes("type") && value !== "" && value !== null) {
      params[key] = value;
      continue;
    }
    if (value !== "" && value !== null) {
      params[key] = value;
    }
  }

  return params;
}

// Fonction pour extraire l'ID à partir de l'IRI
export const getIdFromIRI = (iri) => {
  if (!is(iri)) return null;
  const match = iri.match(/\/(\d+)$/);

  return match ? parseInt(match[1], 10) : null;
};

/**
 * Determines the HTTP method based on the given entity.
 * If the entity is null or undefined, it returns the POST method.
 * Otherwise, it returns the PUT method.
 *
 * @param {any} entity - The entity to determine the HTTP method for.
 * @returns {Object} - The updated entity object with the determined method.
 */
export const determineMethodHttp = (entity) => {
  return {
    ...entity,
    method: entity == null || undefined ? _ACTIONS.POST : _ACTIONS.PUT,
  };
};

export const saveBoolAtrribute = (value) => {
  return value === "" ? false : value;
};

/**
 * Formats a phone number by adding a space after every two digits.
 * @param {string} phoneNumber - The phone number to format.
 * @returns {string} The formatted phone number.
 */
export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "";

  return phoneNumber.replace(/(\d{2})(?=\d)/g, "$1 ");
};

/**
 * Strips HTML tags from the given HTML string.
 *
 * @param {string} html - The HTML string to strip tags from.
 * @returns {string} The resulting string without HTML tags.
 */
export const stripHtml = (html) => {
  var doc = new DOMParser().parseFromString(html, "text/html");

  return doc.body.textContent || "";
};

/**
 * Checks if a string value is equal to "NULL".
 * @param {string} value - The string value to check.
 * @returns {boolean} - Returns true if the value is "NULL", otherwise returns false.
 */
export const checkNullInString = (value) => {
  return value === "NULL" ? true : false;
};

/**
 * Processes sort parameters and returns new sort parameters.
 *
 * @param {Array} params - The sort parameters to process.
 * @return {Object|null} - The new sort parameters.
 */
export const sortingParams = (params) => {
  if (params.length === 0) {
    return "";
  }
  const newSortParams = params[0];
  return { field: newSortParams.field, sort: newSortParams.sort };
};

/**
 * Replaces URLs and email addresses in a given text with clickable links.
 * @param {string} inputText - The text to be linkified.
 * @returns {string} - The linkified text.
 */
export function linkify(inputText) {
  let replacedText, replacePattern1, replacePattern2, replacePattern3;

  //URLs starting with http://, https://, or ftp://
  replacePattern1 =
    /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedText = inputText.replace(
    replacePattern1,
    '<a href="$1" target="_blank">$1</a>',
  );

  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(
    replacePattern2,
    '$1<a href="http://$2" target="_blank">$2</a>',
  );

  //Change email addresses to mailto:: links.
  replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
  replacedText = replacedText.replace(
    replacePattern3,
    '<a href="mailto:$1">$1</a>',
  );

  return replacedText;
}

/**
 * Envoie un requete directement au onChange d'un select pour modifier une valeur en BDD
 *
 * @param {*} value
 * @param {*} field
 * @param {*} url
 */
export async function editInstantRequest(value, url, field) {
  const requestHelper = new RequestHelper();
  if (!url) return;

  url = url.replace(API, "", 1);

  return await requestHelper
    .doRequest(_ACTIONS.PUT, url, { [field]: value })
    .then((response) => {
      if (response.status === _HTTP.ok) {
        // @TODO Garder le toast pour plus tard peut etre
        createToast(
          _SWAL_ICONS.success,
          "La modification du champ a été effectuée avec succès",
        );

        return response.data;
      } else {
        createToast(
          _SWAL_ICONS.error,
          "Une erreur est survenue lors de la modification",
        );

        return response.data;
      }
    });
}

/**
 * Truncates a given text if it exceeds the specified limit.
 *
 * @param {string} text - The text to truncate.
 * @param {number} limit - The maximum length of the truncated text.
 * @returns {string} - The truncated text.
 */
export function ellipsis(text, limit) {
  return text?.length > limit ? text.substring(0, limit) + "..." : text;
}

/**
 * Checks if a string contains a number.
 *
 * @param {string} myString - The string to check.
 * @returns {boolean} - True if the string contains a number, false otherwise.
 */
export function hasNumber(myString) {
  return /\d/.test(myString);
}

/**
 * Rounds a value to the specified number of decimal places.
 *
 * @param {number} value - The value to be rounded.
 * @param {number} decimals - The number of decimal places to round to.
 * @returns {number} - The rounded value.
 */
export function roundValue(value, decimals) {
  return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
}

/**
 * Calculates the number of hours and minutes from the given minutes.
 *
 * @param {number} minutes - The total number of minutes.
 * @param {boolean} [formated=false] - Indicates whether the result should be formatted.
 * @returns {string} - The calculated hours and minutes.
 */
export const minutesInHours = (minutes, formated = false) => {
  if (!minutes || minutes === 0) return 0;
  const hours = minutes / 60;
  if (Math.floor(hours) === 0)
    return formated ? `${minutes}min` : `0:${minutes}`;
  else
    return formated
      ? `${Math.floor(hours)}h${minutes % 60}`
      : `${Math.floor(hours)}:${minutes % 60}`;
};

/**
 * Calculates the start and end dates of the week for a given date.
 *
 * @param {Date} date - The date for which to calculate the week start and end dates.
 * @returns {Object} - An object containing the start and end dates of the week in the format { start: 'YYYY-MM-DD', end: 'YYYY-MM-DD' }.
 */
export const datesStartAndEndWeek = (date) => {
  const weekStart = date.clone().startOf("week").format("YYYY-MM-DD");
  const weekEnd = date.clone().endOf("week").format("YYYY-MM-DD");

  return { start: weekStart, end: weekEnd };
};

export const buildIRI = (ressource, id) => API + ressource + SLASH + id;

/**
 * Converts the first character of a string to lowercase.
 *
 * @param {string} str - The string to convert.
 * @returns {string} The string with the first character converted to lowercase.
 */
export const lowercaseFirst = (str) =>
  `${str.charAt(0).toLowerCase()}${str.slice(1)}`;

export const capitalizeFirst = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Calculates the current fiscal year based on the current date.
 * The fiscal year is assumed to start in July and end in June.
 *
 * @returns {string} A string representing the current fiscal year in the format "YYYY-YYYY".
 */
export const currentFiscalYearDateSelect = () => {
  const fiscalStartYear = actualFiscalYear();

  return `${fiscalStartYear}-${fiscalStartYear + 1}`;
};

/**
 * Generates an array of fiscal years for a select input.
 * The fiscal year starts in July and ends in June of the following year.
 * The function generates fiscal years from 5 years before the current fiscal year
 * to 5 years after the current fiscal year.
 *
 * @returns {string[]} An array of fiscal years in the format "YYYY-YYYY".
 */
export const getOptionsSelectFiscalYear = () => {
  const fiscalStartYear = actualFiscalYear();

  const startYear = fiscalStartYear - 5;
  const endYear = fiscalStartYear + 5;

  const fiscalYears = [];
  for (let year = startYear; year <= endYear; year++) {
    fiscalYears.push(`${year}-${year + 1}`);
  }

  return fiscalYears;
};

export const actualFiscalYear = () => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();

  return currentMonth < 6 ? currentYear - 1 : currentYear;
};

/**
 * Creates an array of column objects with default properties merged with provided columns and properties.
 *
 * @param {Array<Object>} cols - An array of column objects to be customized.
 * @param {Object} props - Additional properties to be merged into each column object.
 * @returns {Array<Object>} An array of column objects with merged properties.
 */
export const createColumn = (cols, props) => {
  if (!cols) return [];
  return cols.map((col) => ({
    flex: 1,
    editable: false,
    sortable: false,
    resizable: false,
    headerClass: "header-center",
    ...col,
    ...props,
  }));
};

export const formatNumber = (number) =>
  new Intl.NumberFormat("fr-FR").format(number);

/**
 * Adds a blank line after each group of rows in the provided data.
 *
 * @param {Array<Object>} rowsData - The array of row objects to process.
 * @returns {Array<Object>} A new array of row objects with blank lines added after each group.
 *
 * @example
 * const rowsData = [
 *   { group: 'A', rowName: 'Row 1', value: 10 },
 *   { group: 'A', rowName: 'Row 2', value: 20 },
 *   { group: 'B', rowName: 'Row 3', value: 30 }
 * ];
 * const result = addblankLine(rowsData);
 * // [
 * //   { group: 'A', rowName: 'Row 1', value: 10 },
 * //   { group: 'A', rowName: 'Row 2', value: 20 },
 * //   { group: 'A', rowName: '', value: null, _SPACER: true },
 * //   { group: 'B', rowName: 'Row 3', value: 30 },
 * //   { group: 'B', rowName: '', value: null, _SPACER: true }
 * // ]
 */
export const addblankLine = (rowsData) => {
  const newRowsData = [];

  for (let i = 0; i < rowsData.length; i++) {
    newRowsData.push(rowsData[i]);

    if (
      i === rowsData.length - 1 ||
      rowsData[i].group !== rowsData[i + 1]?.group
    ) {
      newRowsData.push({
        group: rowsData[i].group,
        rowName: "",
        ...Object.fromEntries(
          Object.keys(rowsData[i])
            .filter((key) => key !== "group" && key !== "rowName")
            .map((key) => [
              key,
              typeof rowsData[i][key] === "number" ? null : "",
            ]),
        ),
        _SPACER: true,
      });
    }
  }

  return newRowsData;
};

export const getOptionsAccountParameter = () => {
  const dataService = new DataService();
  var dataReturn = [];
  dataService
    .doRequest(_ACTIONS.GET, _ROUTES.ACCOUNT_PARAMETERS, {
      active: 1,
      "groups[]": "select:get",
      "order[name]": "ASC",
      "exists[accountNumber]": 1,
      pagination: false,
    })
    .then((response) => {
      const data = response[_MEMBER];
      data.forEach((y) => {
        dataReturn.push({
          value: y["id"],
          label: y.name,
        });
      });
    });
  return dataReturn;
};
